import { Component } from '@angular/core';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import { DynamicFormService } from '@ntap/common';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ItemUtil,
  ItemViewProviderDirective,
  ViewProviderDirective,
  ViewResult,
  ViewResultListener,
  ViewState,
  ViewWindowComponent,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { Observable, filter, first, map, switchMap } from 'rxjs';

@Component({
  selector: 'app-open-konverzija-pojavni-oblik-action',
  templateUrl: './open-konverzija-pojavni-oblik-action.component.html',
  providers: [
    {
      provide: ViewProviderDirective,
      useClass: ItemViewProviderDirective
    },
    {
      provide: ItemViewProviderDirective,
      useExisting: ViewProviderDirective
    },
    {
      provide: ViewResultListener,
      useClass: ViewWindowComponent
    },
    {
      provide: WindowRegistry,
      useClass: WindowRegistry
    },
    {
      provide: DynamicFormService,
      useClass: DynamicFormService
    }
  ]
})
export class OpenKonverzijaPojavniOblikActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  static KONVERZIJA_POJAVNI_OBLIK_VIEW_NAME = 'konverzija_pojavni_oblik_item';

  protected override doExecuteWithItem(): Observable<ItemActionResult> {
    return this.itemProvider.item$.pipe(
      first(),
      switchMap((item: any) => {
        const pojavniOblikId = item['en~pojavni_oblik~id'];
        const itemm: any = {
          $itemType: 'en~pojavni_oblik',
          $mainType: 'en~pojavni_oblik',
          $parentId: pojavniOblikId,
          $parentType: 'en~pojavni_oblik',
          'en~pojavni_oblik~id': pojavniOblikId
        };
        const itemProps =
          (pojavniOblikId && {
            $id: pojavniOblikId,
            $type: 'en~pojavni_oblik',
            $itemType: 'en~pojavni_oblik'
          }) ||
          {};
        const keyItem = ItemUtil.extractItemKey(itemm);
        const viewState = Object.assign({}, keyItem, itemProps);
        return this.doOpenWindow(viewState).pipe(
          filter((viewResult: any) => this.acceptResult(viewResult)),
          map(() => new ItemActionResult(EMPTY_ACTION_RESULT, item))
        );
      })
    );
  }
  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }
  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      OpenKonverzijaPojavniOblikActionComponent.KONVERZIJA_POJAVNI_OBLIK_VIEW_NAME
    );
    return actionWindowParams;
  }
  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
